import { useRef, useState } from "react";
import { Button, Card, Modal } from "semantic-ui-react";
import { dialogControl } from "../../controls/dialog-control";
import { useModalControl } from "../../hooks/commonHooks";
import { hostUrl, httpRequest, restRequest } from "../../http";
import { DataFile } from "../../models/common_model";

export function ImagesInput(props: { name: string, value: DataFile[], containerType: number, containerId: number, onChange: (event: any, data: {name: string, value: DataFile[]}) => void }) {
    const { name, value, containerType, containerId, onChange } = props;
    const viewModalControl = useModalControl();
    const [viewingId, setViewingId] = useState<number>();
    const fileInputRef = useRef<HTMLInputElement>(null);
    const [loading, setLoading] = useState(false);

    return <div style={{ position: 'relative', width: '100%' }}>
        <Card.Group>
            {(value || []).map(image => {

                return <Card key={image.id} image={hostUrl('files/' + image.id)} header={image.name}
                    className={`image_input ${image.deleted ? 'deleted' : ''}`}
                    extra={<Button.Group>
                        <Button icon="search" onClick={e => {
                            e.preventDefault();

                            setViewingId(image.id);
                            viewModalControl.setOpen(true);
                        }} as="a"></Button>
                        {!image.deleted ? <Button icon="delete" onClick={e => {
                            e.preventDefault();

                            onChange({ target: fileInputRef.current }, { name, value: value.map(v => v.id !== image.id ? v : {...v, deleted: true}) });
                        }} color="red" as="a"></Button> : <Button icon="refresh" onClick={e => {
                            e.preventDefault();

                            onChange({ target: fileInputRef.current }, { name, value: value.map(v => v.id !== image.id ? v : {...v, deleted: false}) });
                        }} as="a"></Button>}
                    </Button.Group>}></Card>
            })}

            <div style={{ margin: '13px' }}>
                <Button onClick={e => {
                    e.preventDefault();
                    fileInputRef.current?.click();
                }} icon="add" size="mini" color="blue" as="a"></Button>
            </div>
        </Card.Group>

        <Modal {...viewModalControl.props} closeIcon size="fullscreen">
            <Modal.Content>
                <img src={hostUrl('files/' + viewingId)} />
            </Modal.Content>
        </Modal>

        <input name={name} ref={fileInputRef} type="file" accept="image/x-png,image/gif,image/jpeg" multiple style={{ display: 'none' }} onChange={e => {
            if (fileInputRef.current?.files && fileInputRef.current?.files?.length > 0) {
                setLoading(true);
                const postData = new FormData();
                if (fileInputRef.current?.files) {
                    for (let i = 0; i < fileInputRef.current.files.length; i++) {
                        postData.append('file_' + i, fileInputRef.current.files[i]);
                    }
                }

                httpRequest<DataFile[]>(`files/upload/${containerType}/${containerId}`, postData, 'post', {}).then(result => {
                    fileInputRef.current!.value = '';
                    onChange({ target: fileInputRef.current! }, { name, value: [...value, ...result] });
                }).finally(() => setLoading(false));
            }
        }}></input>
    </div>
}